import { QueryClient } from "@tanstack/react-query";

// Create a client for the query client
// This is a singleton that will be used throughout the app
export const queryClient = new QueryClient();
